import M from "moment";
import * as R from "ramda";
import React, {Component} from "react";
import FlexView from "react-flexview";
import SimpleDataTable from "../../../../modules/SimpleDataTable";
import SimpleDate from "../../../../modules/SimpleDate";
import Button from "../../../../modules/commons/Button";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import {defaultTableChange} from "../../../../modules/custom/customTable";
import SimpleLoadingOverlay from "../../../../modules/popup/SimpleLoadingOverlay";
import {getValueFromDDL, removeNullFields} from "../../../common/mapper";
import {tableColumns, TABS} from "../config";
import MutasiBarangDetail from "./mutasiBarangDetail/mutasiBarangDetail";
import MutasiBarangFilter from "./mutasiBarangFilter";
import SimplePrintTable from "../../../../modules/popup/SimplePrintTable";
import Api from "../../../../Services/Api";
import SimpleAlert from "../../../../modules/popup/SimpleAlert";
import ErrorAction from "../../../../Redux/ErrorRedux";
import {connect} from "react-redux";
import {fetchDataAsync} from "../../../../Services/Utils";
import {HttpStatus} from "../../../common/Constants";

class MutasiBarangContent extends Component {
    tableColumns = [
        ...tableColumns,
        {
            name: "mutationStatus",
            label: "Aksi",
            options: {
                customBodyRender: (val, {rowIndex}) => {
                    const disabledButton = this.isMutasiKeluarTab
                      ? ["PROCESSED", "WAITING_APPROVAL", "WAITING_VERIFICATION", "RECEIVED", "PARTIALLY_RECEIVED", "REJECTED", "REJECTED_APPROVAL"]
                      : ["WAITING_VERIFICATION", "RECEIVED", "PARTIALLY_RECEIVED", "REJECTED"];
                    const isDisabled = disabledButton.includes(val);
                    return (
                        <FlexView style={{gap:'10px'}}>
                                <Button className="btnAct" onClick={() => this.handleDetailVisibility(rowIndex, false , "preview")}>
                                    <i
                                        className="fa fa-lg fa-eye"
                                        style={{
                                            fontSize: 20,
                                            color: "red"
                                        }}
                                    />
                                </Button>
                                <Button 
                                disabled={isDisabled}
                                className="btnAct" 
                                onClick={() => this.handleDetailVisibility(rowIndex)}>
                                    <i
                                        className="fa fa-lw fa-pencil-alt"
                                        style={{
                                            fontSize: 20,
                                            color: isDisabled ? "gray" : "red"
                                        }}
                                    />
                                </Button>
                               {this.isMutasiKeluarTab && <Button 
                                disabled={this.isMutasiKeluarTab && isDisabled}
                                className="btnAct"
                                onClick={() => this.handleDetailVisibility(rowIndex, false, "delete")}>
                                    <i
                                        className="fa fa-lw fa-trash"
                                        style={{
                                            fontSize: 20,
                                            color: this.isMutasiKeluarTab && isDisabled ? "gray" : "red"
                                        }}
                                    />
                                </Button>}
                        </FlexView>
                    );
                },
                sort: false,
            },
        },
    ];

    constructor(props) {
        super(props);
        this.isMutasiKeluarTab = props.tab.name === TABS.mutasiKeluar.name;
        this.state = {
            kodeCabang: {},
            loading: false,
            detailVisible: false,
            id: null,
            filterVisible: false,
            printVisible: false,
            submittedFilterData: {},
            filterData: {
                startMutation: new Date(),
                endMutation: new Date(),
            },
            periode: {
                startMutation: new Date(),
                endMutation: new Date(),
            },
            pagination: {
                totalData: 1,
                limit: 5,
                page: 1,
            },
            dataTable: [],
            alertVisible: false,
            alertTitle: "",
            warningMessage: "",
            skipNextPaginationFetch: false,
            buttonType: null
        };
    }

    async componentDidMount() {
        let request;
        if (this.props.kodeCabang !== null) {
            request = this.isMutasiKeluarTab
                ? {
                    ...this.state.filterData,
                    sourceKodeCabang: this.props.kodeCabang.value,
                    startMutation: this.state.filterData.startMutation || M(new Date()).format("yyyy-MM-DD"),
                    endMutation: this.state.filterData.endMutation || M(new Date()).format("yyyy-MM-DD"),
                }
                : {
                    ...this.state.filterData,
                    targetKodeCabang: this.props.kodeCabang.value,
                    startMutation: this.state.filterData.startMutation || M(new Date()).format("yyyy-MM-DD"),
                    endMutation: this.state.filterData.endMutation || M(new Date()).format("yyyy-MM-DD"),
                }
            this.triggerLoading();
            await this.fetchData(request || {});
            this.triggerLoading();
        }
        this.setState((prevValue) => ({
            ...prevValue,
            submittedFilterData: {
                startMutation: M(this.state.filterData.startMutation).format("yyyy-MM-DD"),
                endMutation: M(this.state.filterData.endMutation).format("yyyy-MM-DD"),
            }
        }))
    }

    async componentDidUpdate(prevProp, prevState) {
        if (prevProp.kodeCabang !== this.props.kodeCabang) {
            this.setState(prev=>({
                ...prev,
                skipNextPaginationFetch: true,
                pagination:{
                    ...prev.pagination,
                    limit: 5, 
                    page: 1
                }
            }));
            this.handleRefresh()
        }
        if (
            (prevState.pagination.page !== this.state.pagination.page ||
                prevState.pagination.limit !== this.state.pagination.limit) && !this.state.skipNextPaginationFetch
        ) {
            this.triggerLoading();
            await this.fetchData(
                this.state.submittedFilterData,
                this.state.pagination.page,
                this.state.pagination.limit
            );
            this.triggerLoading();
        }
        if (this.state.skipNextPaginationFetch) {
            this.setState({skipNextPaginationFetch: false});
        }
    }

    fetchData = async (filter = {}, page = 1, limit = 5) => {
        let request = this.props.tab.name === "mutasiKeluar" && !R.isNil(filter.mutationStatus)
            ? {
                ...this.state.filterData,
                ...filter,
                sourceKodeCabang: this.props.kodeCabang.value,
                mutationStatus: [filter.mutationStatus]
            }
            : this.props.tab.name === "mutasiKeluar"
                ? {
                    ...this.state.filterData,
                    ...filter,
                    sourceKodeCabang: this.props.kodeCabang.value,
                    mutationType: "OUT"
                }
                : {
                    ...this.state.filterData,
                    ...filter,
                    targetKodeCabang: this.props.kodeCabang.value,
                    // mutationStatus: !R.isNil(filter.mutationStatus) ? [filter.mutationStatus] : ["PROCESSED", "WAITING_VERIFICATION", "RECEIVED", "REJECTED", "PARTIALLY_RECEIVED", "REJECT_APPROVE"],
                    mutationType: "IN"
                }

        const response = await this.props.tab.getAll(
            {
                paramFilters: request,
                page,
                limit,
            },
            this.props.setError,
        );
        if (response.ok) {
            this.setState((prevValue) => ({
                ...prevValue,
                pagination: {
                    ...prevValue.pagination,
                    totalData: response.data.totalData,
                },
                dataTable: response.data.data,
            }));
        }
    };

    triggerLoading = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            loading: !prevValue.loading,
        }))
    }

    handleValueChange = (name, value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            periode: {
                ...prevValue.periode,
                [name]: value,
            },
        }));
    };

    handleFilterVisibility = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            filterData: {
                ...prevValue.filterData,
                startMutation: null,
                endMutation: null,
            },
            filterVisible: !prevValue.filterVisible,
        }));
    };

    handleFilterValueChange = (name, value) => {
        if (!R.equals(name, "endMutation") && !R.equals(name, "startMutation")) {
            this.setState((prevValue) => ({
                ...prevValue,
                filterData: {
                    ...prevValue.filterData,
                    [name]: value,
                },
            }));
            return;
        }

        if (R.equals(name, "endMutation") && M(value).isBefore(this.state.filterData.startMutation)) {
            this.setState((prevValue) => ({
                ...prevValue,
                filterData: {
                    ...prevValue.filterData,
                    startMutation: value,
                    endMutation: value,
                },
            }));
            return;
        }

        this.setState((prevValue) => ({
            ...prevValue,
            filterData: {
                ...prevValue.filterData,
                [name]: value,
            },
        }));
    };

    handleDetailVisibility = async (index, tambah = false, buttonType = null) => {
        console.log(buttonType,'buttonType')
        if (tambah) {
            this.setState((prevValue) => ({
                ...prevValue,
                // id: null,
                detailVisible: true,
                buttonType: buttonType
            }));
        } else if (index || index === 0) {
            this.setState((prevValue) => ({
                ...prevValue,
                id: this.state.dataTable[index].mutationNo,
                detailVisible: true,
                buttonType: buttonType
            }));
        } else {
            this.setState((prevValue) => ({
                ...prevValue,
                id: null,
                detailVisible: false,
                buttonType: buttonType
            }));
        }
    };

    handleRefresh = async () => {
        this.triggerLoading();
        // this.setState(prev => ({
        //     ...prev,
        //     periode: {
        //         startMutation: new Date(),
        //         endMutation: new Date(),
        //     }
        // }))

        const request = {
            ...this.state.submittedFilterData,
            // startMutation: M().format("YYYY-MM-DD"),
            // endMutation: M().format("YYYY-MM-DD"),
        };

        if (this.isMutasiKeluarTab) {
            request.sourceKodeCabang = this.props.kodeCabang.value;
        } else {
            request.targetKodeCabang = this.props.kodeCabang.value;
        }

        await this.fetchData(request, this.state.pagination.page, this.state.pagination.limit);
        this.triggerLoading();
    }

    handleResetFilter = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            filterData: {
                startMutation: null,
                endMutation: null,
            },
        }));
    };

    handleSubmitFilter = async (e) => {
        e.preventDefault();
        this.setState((prevValue) => ({
            ...prevValue,
            periode: {},
            loading: true,
            pagination: {
                ...prevValue.pagination,
                page: 1,
            },
        }));

        this.setState({skipNextPaginationFetch: true});
        const request = removeNullFields({
            ...this.state.filterData,
            ...this.getAllDDLValue(this.state.filterData),
            startMutation: this.state.filterData.startMutation == null ? null : M(this.state.filterData.startMutation).format("YYYY-MM-DD"),
            endMutation: this.state.filterData.endMutation == null ? null : M(this.state.filterData.endMutation).format("YYYY-MM-DD"),
        });
        await this.fetchData(request, 1, this.state.pagination.limit);
        this.setState((prevValue) => ({
            ...prevValue,
            submittedFilterData: request,
            filterVisible: false,
            loading: false,
        }));
    };

    handleChangePage = (tableState) => {
        let limit = tableState.rowsPerPage;
        let page = tableState.page + 1;
        this.setState((prevValue) => ({
            ...prevValue,
            pagination: {
                ...prevValue.pagination,
                page: page,
                limit: limit,
            },
        }));
    };

    handleChangeRowsPerPage = (tableState) => {
        let limit = tableState.rowsPerPage;
        this.setState((prevValue) => ({
            ...prevValue,
            pagination: {
                ...prevValue.pagination,
                count: 1,
                page: 1,
                limit: limit,
            }
        }));
    };

    handlePeriodeChange = (name, value) => {
        if (R.equals(name, "endMutation") && M(value).isBefore(this.state.periode.startMutation)) {
            this.setState((prevValue) => ({
                ...prevValue,
                periode: {
                    endMutation: value,
                    startMutation: value,
                },
            }));
            return;
        }

        this.setState((prevValue) => ({
            ...prevValue,
            periode: {
                ...prevValue.periode,
                [name]: value,
            },
        }));
    };

    handlePrint = () => {
        this.setState((prevVallue) => ({
            ...prevVallue,
            printVisible: !prevVallue.printVisible,
        }))
    };

    handleSearch = async () => {
        this.setState((prevValue) => ({
            ...prevValue,
            filterData: {},
            loading: true,
            pagination: {
                ...prevValue.pagination,
                page: 1
            }
        }));
        this.setState({skipNextPaginationFetch: true});

        const baseRequest = this.isMutasiKeluarTab
            ? {sourceKodeCabang: this.props.kodeCabang.value}
            : {targetKodeCabang: this.props.kodeCabang.value}

        const request = {
          ...baseRequest,
          startMutation: M(this.state.periode.startMutation).format("YYYY-MM-DD"),
          endMutation: M(this.state.periode.endMutation).format("YYYY-MM-DD"),
        };

        await this.fetchData(
          request,
          1,
          this.state.pagination.limit
        );
        this.setState((prevValue) => ({
            ...prevValue,
            submittedFilterData: request,
            loading: false,
        }));
    };

    getAllDDLValue = (data) => {
        if (!R.isNil(data)) {
            return {
                sourceKodeCabang: getValueFromDDL(data, "sourceKodeCabang"),
                sourceKodeLocator: getValueFromDDL(data, "sourceKodeLocator"),
                targetKodeCabang: getValueFromDDL(data, "targetKodeCabang"),
                targetKodeLocator: getValueFromDDL(data, "targetKodeLocator"),
                mutationStatus: getValueFromDDL(data, "mutationStatus"),
                variantCode: getValueFromDDL(data, "variantCode"),
                kodeKsu: getValueFromDDL(data, "kodeKsu"),
                kodeHadiah: getValueFromDDL(data, "kodeHadiah"),
                kodeBarang: getValueFromDDL(data, "kodeBarang"),
            };
        }

        return {};
    };

    handleRejectAll = async (data) => {
        this.triggerLoading();
        let req = {
            mutationNo: this.state.id,
            mutationNote: R.isNil(data.mutationNote) ? "" : data.mutationNote,
            mutationTargetKodeLocator: data.mutationTargetKodeLocator?.value
        }

        let res = await this.callApi(
            Api.create("NAGAMAS_TRANSACTION").rejectAllMutation,
            req,
        );
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            let request = this.isMutasiKeluarTab
                ? {
                    ...this.state.filterData,
                    sourceKodeCabang: this.props.kodeCabang.value,
                    startMutation: this.state.filterData.startMutation || M(new Date()).format("yyyy-MM-DD"),
                    endMutation: this.state.filterData.endMutation || M(new Date()).format("yyyy-MM-DD"),
                }
                : {
                    ...this.state.filterData,
                    targetKodeCabang: this.props.kodeCabang.value,
                    startMutation: this.state.filterData.startMutation || M(new Date()).format("yyyy-MM-DD"),
                    endMutation: this.state.filterData.endMutation || M(new Date()).format("yyyy-MM-DD"),
                }
            this.handleDetailVisibility();
            await this.fetchData(request || {}, this.state.pagination.page, this.state.pagination.limit);
            this.handleAlertModalVisibility("Data mutasi barang masuk telah ditolak", "Proses Data Mutasi");
        }
        this.triggerLoading();
    }

    handleAlertModalVisibility = (text, title) => {
        this.setState((prevState) => ({
            ...prevState,
            alertVisible: !prevState.alertVisible,
            alertTitle: title || "",
            warningMessage: text || "",
        }))
    }

    callApi = async (api, args) => {
        return await fetchDataAsync({
            asyncFn: api,
            menuName: "Mutasi Barang",
            setError: this.props.setError,
            args: args,
        });
    }

    render() {
        return (
            <>
                <FlexView
                    style={{justifyContent: "space-between"}}
                    vAlignContent="center"
                    className="margin-top-5px"
                >
                    <FlexView vAlignContent="center" style={{gap: "10px"}}>
                        <p className="margin-bottom-20px">Periode: </p>
                        <SimpleDate
                            id="select_date_period_from"
                            name="startMutation"
                            nextdate
                            date={this.state.periode.startMutation}
                            maxDate={this.state.periode.endMutation}
                            onChange={(value) => this.handlePeriodeChange("startMutation", value)}
                        />
                        <span className="margin-bottom-20px">s/d</span>
                        <SimpleDate
                            id="select_date_period_to"
                            name="endMutation"
                            nextdate
                            date={this.state.periode.endMutation}
                            onChange={(value) => this.handlePeriodeChange("endMutation", value)}
                        />
                        <SimpleButton className="margin-bottom-20px" onClick={this.handleSearch}>
                            Cari
                        </SimpleButton>
                    </FlexView>
                    <Button
                        type="button"
                        onClick={this.handleFilterVisibility}
                        className="btn background-red margin-bottom-20px"
                    >
            <span>
              <i className="fa fa-qrcode"></i>
            </span>
                    </Button>
                </FlexView>
                <SimpleDataTable
                    key={`${this.state.pagination.totalData}-${this.state.pagination.page}`}
                    data={this.state.dataTable}
                    columns={this.tableColumns}
                    toCount={this.state.pagination.totalData}
                    rowsPerPage={this.state.pagination.limit}
                    page={this.state.pagination.page - 1}
                    options={defaultTableChange(
                        (tableState) => this.handleChangePage(tableState),
                        (tableState) => this.handleChangeRowsPerPage(tableState),
                    )}
                    footerAdditionalButtons={
                        <>
                            {this.isMutasiKeluarTab && (<SimpleButton
                                icon={<i className="fa fa-plus margin-right-10px"/>}
                                onClick={() => this.handleDetailVisibility(null, true)}
                            >Tambah</SimpleButton>)}
                            <SimpleButton onClick={this.handlePrint}>Cetak</SimpleButton>
                        </>
                    }
                />
                {this.state.filterVisible && (
                    <MutasiBarangFilter
                        state={this.state}
                        mutasiKeluarTab={this.isMutasiKeluarTab}
                        onReset={this.handleResetFilter}
                        onSubmit={this.handleSubmitFilter}
                        onValueChange={this.handleFilterValueChange}
                        onClickClose={() => this.handleFilterVisibility()}
                    />
                )}
                {this.state.detailVisible && (
                    <MutasiBarangDetail
                        setError={this.props.setError}
                        tab={this.props.tab}
                        mutasiKeluarTab={this.isMutasiKeluarTab}
                        state={this.state}
                        handleRejectAll={this.handleRejectAll}
                        kodeCabang={this.props.kodeCabang}
                        onRefresh={() => this.handleRefresh()}
                        onClickClose={() => this.handleDetailVisibility()}
                    />
                )}
                {this.state.loading && <SimpleLoadingOverlay active={this.state.loading}/>}
                {this.state.printVisible && (
                    <SimplePrintTable onClearPrint={this.handlePrint}/>
                )}
                {this.state.alertVisible && (
                    <SimpleAlert
                        title={this.state.alertTitle || "Information"}
                        content={
                            <div>
                                <p>
                                    {this.state.warningMessage}
                                </p>
                            </div>
                        }
                        visible={this.state.alertVisible}
                        onClickClose={this.handleAlertModalVisibility}
                        additionalButtons={
                            <>
                                <SimpleButton
                                    type="button"
                                    text="OK"
                                    onClick={() => this.handleAlertModalVisibility()}
                                />
                            </>
                        }
                    />
                )}
                {this.state.loading && <SimpleLoadingOverlay active={this.state.loading}/>}
            </>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setError: (payload) => dispatch(ErrorAction.setError(payload)),
    };
};

export default connect(null, mapDispatchToProps)(MutasiBarangContent);
